import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';
import { PipesModule } from '../../callback.pipes.module';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { OrderModule } from 'ngx-order-pipe';
import { NgxPaginationModule } from 'ngx-pagination';
import { ProjectOutcomeManagementPage } from './project-outcome-management.page';

const routes: Routes = [
  {
    path: '',
    component: ProjectOutcomeManagementPage
  }
];

@NgModule({
  imports: [
    PipesModule,
    FilterPipeModule,
    OrderModule,
    NgxPaginationModule,
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [ProjectOutcomeManagementPage]
})
export class ProjectOutcomeManagementPageModule {}
